import { render, staticRenderFns } from "./caddesossa.vue?vue&type=template&id=551ccf98&"
import script from "./caddesossa.vue?vue&type=script&lang=js&"
export * from "./caddesossa.vue?vue&type=script&lang=js&"
import style0 from "./caddesossa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports